import {v1_PublisherPostStatus_select_column} from '../../generated/types';

const PublisherPostStatus = {
    ...v1_PublisherPostStatus_select_column,
    res: 'v1_PublisherPostStatus',
    comp: {},
    rel: {},
};

export default PublisherPostStatus;
